interface CalendarIllustrationProps {
  day?: string;
  month?: string;
  header?: string;
  showStroke?: boolean;
  className?: string;
}

const CalendarIllustration = ({
  day = "19",
  month = "APR",
  header,
  showStroke = true,
  ...rest
}: CalendarIllustrationProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      fill="none"
      viewBox="0 0 206 215"
    >
      <rect
        width="215"
        height="206"
        x="206"
        fill="#8065C9"
        rx="7"
        transform="rotate(90 206 0)"
        stroke="#8065C9"
        strokeWidth={showStroke ? "2" : "0"}
      ></rect>
      {header ? (
        <text
          fontSize={"32px"}
          y="35"
          x="50%"
          width={100}
          fontFamily="Poppins"
          textAnchor="middle"
          fontWeight={400}
          fill="#fff"
          className="uppercase"
        >
          {header}
        </text>
      ) : (
        <g fill="#fff">
          <path
            d="M5.705 1.028H0v22.294h5.705V1.028zM8.063 1.028h17.239v4.558H13.768V9.68h11.503v4.465H13.768v4.621h11.596v4.557H8.062V1.028zM27.492 1.028h5.737v17.457h10.48v4.837H27.491V1.028zM45.863 5.555h-6.386V1.03h18.51v4.526H51.57v17.768h-5.706V5.555zM63.704 15.912c.062 2.543 1.488 3.845 4.217 3.845 2.388 0 3.659-.838 3.659-2.202 0-.745-.341-1.302-.869-1.582-1.333-.682-3.875-1.115-7.13-2.418-3.225-1.267-4.9-3.41-4.9-6.17 0-4.19 3.314-6.977 8.9-6.977 5.424 0 8.742 2.916 8.742 7.349h-5.36c-.249-2.078-1.46-3.039-3.752-3.039-1.924 0-3.1.899-3.1 2.015 0 1.676 1.736 2.017 5.24 3.164 2.573.837 4.434 1.425 5.518 2.293 1.462 1.179 2.203 2.791 2.203 4.714 0 4.34-3.442 7.038-9.707 7.038-5.797 0-8.805-2.63-9.146-8.03h5.485zM80.864 3.534l.643-1.961h.017a22.8 22.8 0 00-.024.584v1.377h.494V1.03h-.723l-.628 1.915h-.01l-.588-1.915h-.723v2.504h.475v-1.17c0-.132-.011-.399-.033-.8h.015l.603 1.965.482.005zm-2.592-2.062h.682V1.03h-1.891v.442h.682v2.062h.53l-.003-2.062z"
            transform="translate(58.612 12.524)"
          ></path>
        </g>
      )}
      <g>
        <rect
          width="167"
          height="205"
          x="205"
          y="48"
          fill="#fff"
          rx="7"
          transform="rotate(90 206 48)"
          stroke="#8065C9"
          strokeWidth={showStroke ? "2" : "0"}
        ></rect>

        <text
          fontSize={"96px"}
          y="150"
          x="50%"
          width={100}
          fontWeight={600}
          fontFamily="Poppins"
          fill="#8065C9"
          textAnchor="middle"
        >
          {day}
        </text>
        <text
          y="198"
          x="50%"
          textAnchor="middle"
          width={100}
          fontSize={"48px"}
          fontFamily="Poppins"
          fill="#8065C9"
          className="uppercase"
          fontWeight={"400"}
        >
          {month}
        </text>
      </g>
    </svg>
  );
};

export default CalendarIllustration;
